import { CSSObject } from "@emotion/react";

export const headerSection: CSSObject = {
  flex: "0 0 20%",
};

export const headerContent: CSSObject = {
  display: "flex",
  justifyContent: "flex-start",
};

export const iconAndTitleSection: CSSObject = {
  width: "40%",
  marginRight: "25px",
};

export const title: CSSObject = {
  color: "#0052C4",
  margin: "8px 8px 0px",
};

export const articleTitle: CSSObject = {
  color: "#0052C4",
  margin: "6px 8px",
  lineHeight: "1.2em",
};

export const nameClassDateSection: CSSObject = {
  width: "50%",
};

export const smallText: CSSObject = {
  margin: "5px 0",
  borderBottom: "2px solid #0A6EFA",
  fontSize: "0.8em",
  width: "100%",
};

export const nameClassDateRow: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "5px",
};
